import { render, staticRenderFns } from "./simulador.vue?vue&type=template&id=c7bce4e0"
import script from "./simulador.vue?vue&type=script&lang=js"
export * from "./simulador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports